<template>
    <v-card flat>
        <v-card-title class="subheading">
            Give Access to Company
            <v-spacer/>
            <v-btn small  @click="closeDialog" class="teal white--text">Apply </v-btn>
            <v-icon @click="closeDialog" small class="grey--text">fas fa-times</v-icon>
        </v-card-title>
        <hr>
        <v-card-text>
          <!--   <v-text-field  single-line hide-details v-model="email_domain" label="Please Select the Email Domain of  the Users" /> -->
         <template v-for="company in companies">
                <v-layout row wrap>
                    <v-flex xs1 class="text-xs-left body-2">
                        <v-icon style="padding:10px" v-if="company.access" small class="teal--text"> fas fa-check-circle</v-icon>
                    </v-flex>
                    <v-flex xs5 class="text-xs-left body-2" style="padding:10px">
                        {{company.id}}-
                        {{company.name}}
                    </v-flex>
                    <v-flex xs6 class="text-xs-left">
                       <v-btn v-if="company.access"  @click="removeFromCompany(company)" 
                          small class="red white--text">
                            Remove
                        </v-btn> 
                        <v-btn  v-if="!company.access" @click="addToCompany(company)"
                             small class="green white--text">
                            Grant
                        </v-btn> 
                    </v-flex>
                </v-layout>
            </template>   
        </v-card-text>
    </v-card>
</template>
<script>

import ReportModel from '@/api/service/ReportService';
import CompanyModel from '@/api/service/CompanyService'
import lodash from 'lodash'
export default {
    props: [
        "reportId","reportName",
        "companies","selectedCompany"
    ],
    data() {
        return {
            companyList:[],
            email_domain:""
        }
    },
    created: function() {
      this.getReports()
    },
    mounted:function () {

    },
    methods: {
        getReports() {
          CompanyModel.findAll({})
            .then(response => {
                this.setCompany(response)

            }).catch(error => {
                console.log(error)
          }); 
        },
        setCompany($company) {
            this.companies =$company
            var $ids= lodash.map(this.selectedCompany,'team');
           
            for(var $i=0;$i<this.companies.length;$i++) {
                if($ids.indexOf(this.companies[$i].team)>=0) {
                    this.companies[$i].access=true
                } else {
                    this.companies[$i].access=false
                }
            }
            this.$forceUpdate()

        },
        setPublishedData($reports) {
            this.companyList=[]
            //var $companyList
            for(var $i=0;$i<$reports.length;$i++) {
                this.companyList.push($reports[$i].published_reports.company_id)
            }
        },
        addToCompany($company) {
            $company.access=true
            this.$forceUpdate()
        },
        removeFromCompany($company) {
            $company.access=false
            this.$forceUpdate()
        },
        closeDialog() {
            this.$emit('closeDialog',this.companies,this.email_domain)
        },
        getPublishedReports() {
            ReportModel.getReportForCompany2({"id":this.reportId.id})
            .then(response => {
                //this.published = response
                this.setPublishedData(response)
            }).catch(error => {
                console.log(error)
          }); 
        }
    }
}
</script>